import { render, staticRenderFns } from "./recursos-sgsst-editar.vue?vue&type=template&id=8efc8178&scoped=true&"
import script from "./recursos-sgsst-editar.vue?vue&type=script&lang=js&"
export * from "./recursos-sgsst-editar.vue?vue&type=script&lang=js&"
import style0 from "./recursos-sgsst-editar.vue?vue&type=style&index=0&id=8efc8178&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efc8178",
  null
  
)

export default component.exports